import RcPagination from 'rc-pagination';
import 'rc-pagination/dist/rc-pagination.min.css';
import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { getRankApps } from '../../actions/topn';
import ALineCard from '../../components/ALineCard/ALineCard';
import LineCard from '../../components/LineCard/LineCard';
import LineCardDReco from '../../components/LineCardDReco/LineCardDReco';
import Loading from '../../components/Loading/Loading';
import styles from './TopnMore.module.less';

const selectSearchRecommend = createSelector(
  state => state.search,
  search => search.searchRecommend,
);
const selectRankApps = createSelector(
  state => state.topn,
  topn => topn.rankApps,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(props => {
  const dispatch = useDispatch();
  const rankAppsData = useSelector(selectRankApps);
  const searchRecommend = useSelector(selectSearchRecommend);
  const logInfoData = useSelector(selectLogInfo);
  const { match } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 12;
  const [isChange, setIsChange] = useState(false);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Rank_More_Page||${match.params.code}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            code: match.params.code,
          },
        }),
      );
    };
  }, []);

  const changeNum = (pageIndex, pSize) => {
    setCurrentPage(pageIndex);
    setIsChange(true);
    setTimeout(() => {
      setIsChange(false);
    }, 500);
    dispatch(
      getRankApps({
        skip: (pageIndex - 1) * pSize,
        limit: pSize,
        code: match.params.code || '',
      }),
    );

    // 猜你喜欢 切换页面打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Paging',
        label: '',
        param2: {
          source: `RankMorePage||${rankAppsData.code}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          pagenum: pageIndex,
        },
      }),
    );
  };

  useEffect(() => {
    if (
      !rankAppsData ||
      !rankAppsData.apps ||
      rankAppsData.apps.length === 0 ||
      rankAppsData.limit !== pageSize ||
      (rankAppsData && rankAppsData.code && rankAppsData.code !== match.params.code)
    ) {
      dispatch(getRankApps({ skip: 0, limit: pageSize, code: match.params.code }));
    } else {
      if (!total) {
        setTotal(rankAppsData.count);
      }
      setCurrentPage(parseInt(rankAppsData.skip, 10) / pageSize + 1);
    }
  }, [dispatch, rankAppsData]);

  useEffect(() => {
    // 排行更多页面 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Rank_More_Page',
        label: '',
        param2: {
          source: `Rank_More_Page||${match.params.code}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: `Rank_More_Page||${match.params.code}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);

  return (
    <>
      <div className={styles.recommend_guess_likes}>
        {isChange === false &&
        rankAppsData &&
        rankAppsData.apps &&
        rankAppsData.apps.length > 0 &&
        rankAppsData.code === match.params.code ? (
          <div>
            <div className={styles.recommend_header}>
              <div className={styles.recommend_header_title}>
                {rankAppsData.desc || match.params.title}
              </div>
            </div>
            <div className={styles.app_cards}>
              {rankAppsData.apps.map((soft, i) =>
                soft.androidType === '1' ? (
                  <React.Fragment key={i}>
                    <ALineCard
                      logInfo={{ source: `Rank_More_Page||${match.params.code}` }}
                      soft={soft}
                      key={i}
                    />
                    {searchRecommend[soft.packageName] &&
                      searchRecommend[soft.packageName].apps &&
                      searchRecommend[soft.packageName].apps.length > 4 && (
                        <LineCardDReco
                          recommendData={searchRecommend[soft.packageName]}
                          logInfo={{
                            source: `Rank_More_Page||${match.params.code}||DReco||${soft.packageName}`,
                            source_p: logInfoData.source_p,
                            source_pp: logInfoData.source_pp,
                          }}
                        />
                      )}
                  </React.Fragment>
                ) : (
                  <React.Fragment key={i}>
                    <LineCard
                      logInfo={{ source: `Rank_More_Page||${match.params.code}` }}
                      soft={soft}
                    />
                    {searchRecommend[soft.softID] &&
                      searchRecommend[soft.softID].apps &&
                      searchRecommend[soft.softID].apps.length > 4 && (
                        <LineCardDReco
                          recommendData={searchRecommend[soft.softID]}
                          logInfo={{
                            source: `Rank_More_Page||${match.params.code}||DReco||${soft.softID}`,
                            source_p: logInfoData.source_p,
                            source_pp: logInfoData.source_pp,
                          }}
                        />
                      )}
                  </React.Fragment>
                ),
              )}
              {total > pageSize && (
                <RcPagination
                  size="small"
                  current={currentPage}
                  pageSize={pageSize}
                  defaultPageSize={pageSize}
                  total={total}
                  onChange={changeNum}
                  showSizeChanger
                  className={styles.page_RcPagination}
                />
              )}
            </div>
          </div>
        ) : (
          <div className={styles.loading}>
            <Loading />
          </div>
        )}
      </div>
    </>
  );
});
